import P1P2IncidentsTable from './P1P2IncidentsTable';
import Search from './Search';
import { useContext, useState, useEffect } from 'react';
import { TableContext } from '../context';
import Loader from './Loader';
import SubscribeDialog from './SubscribeDialog';
import { McTabBar } from "@maersk-global/mds-react-wrapper/components-core/mc-tab-bar";
import { McTab } from "@maersk-global/mds-react-wrapper/components-core/mc-tab";

function P1P2Incidents() {
  const { 
    graphData, 
    p1p2IncidentsData,
    setP1P2IncidentsData,
    loading, 
    setLoading, 
    tokenFetched, 
    setTokenFetched, 
    getP1P2IncidentsData, 
    search, 
    setSearch,
    activeP1P2Tab,
    setActiveP1P2Tab,
    searchType,
    userRole,
  } = useContext(TableContext);

  const tabLabels = ["All P1/P2 Incidents", "P1/P2 due to change"];

  useEffect(() => {
    if (tokenFetched) {
      getP1P2IncidentsData(activeP1P2Tab);
    }
  }, [tokenFetched, search, searchType, activeP1P2Tab]);

  // Show loader while userRole is being fetched
  if (userRole === null) {
    return <Loader />;
  }

  if (userRole !== 'Admin' && userRole !== 'Change_Manager') {
    return <div style={{ textAlign: 'center', marginTop: '50px' }}>Unauthorized Access</div>;
  }

  const handleTabChange = (e) => {
    setLoading(true);
    console.log("Tab change event:", e);
    // Get the tab index from e.detail
    const tabIndex = e.detail;
    // Map the index to the corresponding label
    const newTabLabel = tabLabels[tabIndex];
    console.log("Tab changed to:", newTabLabel);
    setActiveP1P2Tab(newTabLabel);
    getP1P2IncidentsData(newTabLabel);
  };

  const getMainTabIndex = () => {
    if (activeP1P2Tab === "All P1/P2 Incidents") return 0;
    if (activeP1P2Tab === "P1/P2 due to change") return 1;
    return 0; // default to first tab
  };

  return (
    <>
      <div className='home'>
        <div className='search' style={{display: 'flex', justifyContent: 'space-between', margin: '30px 40px 45px'}}>
            <Search />
        </div>
        <div style={{ margin: "0 40px" }}>
          <McTabBar tabchange={handleTabChange} currentindex={getMainTabIndex()}>
            <McTab slot="tab" label="All P1/P2 Incidents" active={activeP1P2Tab === "All P1/P2 Incidents"}></McTab>
            <div slot="panel">
              {
                <P1P2IncidentsTable
                  Header1="Incident ID"
                  Header2="Application ID"
                  Header3="Configuration Item"
                  Header4="Short Description"
                  Header5="Resolved At"
                  Header6="Opened At"
                  Header7="Priority"
                  Header8="Brand"
                  Header9="MVC"
                  Header10="Platform"
                  Header11="Portfolio"
                  Header12="Caused By Platform"
                  Header13="Caused By Portfolio"
                  Header14="Caused By Change"
                  isLoading={loading}
                />}
            </div>
            <McTab slot="tab" label="P1/P2 due to change" active={activeP1P2Tab === "P1/P2 due to change"}></McTab>
            <div slot="panel">
              {
                <P1P2IncidentsTable
                  Header1="Incident ID"
                  Header2="Application ID"
                  Header3="Configuration Item"
                  Header4="Short Description"
                  Header5="Resolved At"
                  Header6="Opened At"
                  Header7="Priority"
                  Header8="Brand"
                  Header9="MVC"
                  Header10="Platform"
                  Header11="Portfolio"
                  Header12="Caused By Platform"
                  Header13="Caused By Portfolio"
                  Header14="Caused By Change"
                  Header15="Change Type"
                  Header16="Change Process"
                  Header17="Triggering Change Request"
                  Header18="Observations"
                  Header19="Root Cause Code"
                  Header20="Root Cause Sub Code"
                  isLoading={loading}
                />
              }
            </div>
          </McTabBar>
        </div>       
      </div>
      {<SubscribeDialog/>}
    </>
  );
}

export default P1P2Incidents;
